// @flow
import React from "react";
import ReactDOM from "react-dom";
import EnvanteriumLanding from "./EnvanteriumLanding";
import registerServiceWorker from "./Utilities/Workers/registerServiceWorker";

import "./Assets/Theme/css/page.min.css";
import "./Assets/css/global.css";

window.jQuery = window.$ = require("jquery/dist/jquery.min");
require("./Assets/Theme/js/page.min.js");
require("./Assets/Theme/js/script");

const root = document.getElementById("envanterium-landing");
if (root == null) {
  throw new Error("Envanterium-landing root bulunamadı.");
}

ReactDOM.render(<EnvanteriumLanding />, root);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js